import { Async as OldAsync } from '../../../weborder/Data';
import { OrderHistory, Reorder } from '../../api/order/order.types';
import { Async } from '../../types/data.types';
import {
  ReorderType,
  SetOrderHistory,
  SetReorderOrderId,
  SetReorders,
  SetUnavailableReorderItems,
} from './order.types';

export const setOrderHistory = (
  orderHistory: OldAsync<OrderHistory[]>,
): SetOrderHistory => ({
  type: 'SET_ORDER_HISTORY',
  payload: orderHistory,
});

// TODO - remove as part of ORD-866
export const setReorderOrderId = (orderId: number): SetReorderOrderId => ({
  type: 'SET_REORDER_ORDER_ID',
  payload: orderId,
});

export const setReorders = (
  reorders: Async<Reorder[]>,
  reorderType: ReorderType,
  prId?: number,
): SetReorders => ({
  type: 'SET_REORDERS',
  payload: { reorders, reorderType, prId },
});

export const setUnavailableReorderItems = (
  items: string[],
): SetUnavailableReorderItems => ({
  type: 'SET_UNAVAILABLE_REORDER_ITEMS',
  payload: items,
});
